import React from 'react';
import {
  GlobalOutlined,
  FilePdfOutlined,
  FileTextOutlined,
  FileMarkdownOutlined,
  FileWordOutlined,
  FilePptOutlined,
  FileExcelOutlined,
  FileImageOutlined,
  FileOutlined,
} from '@ant-design/icons';

const SOURCE_TYPE_ICONS = {
  web: { icon: GlobalOutlined, color: '#1890ff' },
  pdf: { icon: FilePdfOutlined, color: '#f5222d' },
  txt: { icon: FileTextOutlined, color: '#8c8c8c' },
  md: { icon: FileMarkdownOutlined, color: '#333333' },
  doc: { icon: FileWordOutlined, color: '#2b579a' },
  docx: { icon: FileWordOutlined, color: '#2b579a' },
  pptx: { icon: FilePptOutlined, color: '#d04423' },
  xlsx: { icon: FileExcelOutlined, color: '#217346' },
  image: { icon: FileImageOutlined, color: '#722ed1' },
  text: { icon: FileTextOutlined, color: '#8c8c8c' },
  other: { icon: FileOutlined, color: '#9ca3af' },
};

/**
 * Returns the appropriate icon element for a note.
 * Priority: favicon_base64 > source_type icon > default FileTextOutlined.
 *
 * @param {object} note - The note object
 * @param {object} [style] - Optional style overrides for the icon
 * @returns {React.ReactElement}
 */
export function getNoteIcon(note, style = {}) {
  if (note?.favicon_base64) {
    return (
      <img
        src={note.favicon_base64}
        alt=""
        style={{ width: '16px', height: '16px', marginRight: '8px', flexShrink: 0, objectFit: 'contain', ...style }}
      />
    );
  }

  const entry = SOURCE_TYPE_ICONS[note?.source_type] || { icon: FileTextOutlined, color: '#9ca3af' };
  const iconStyle = { fontSize: '16px', color: entry.color, marginRight: '8px', flexShrink: 0, ...style };
  return <entry.icon style={iconStyle} />;
}
